import PropTypes from 'prop-types';
import { Component } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { getStepByError } from '../../utils/editUtils';
import ErrorsAndWarningsTooltipHeader from './ErrorsAndWarningsTooltipHeader';
import { ErrorTypes } from '../../constants/edit/ArticleValidationConstants';
import { List } from 'foundations-components/transitional/components/List';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const I18N_PREFIX = 'knowledgeContentUI.edit.categorize.errorsTooltip';
class ErrorsTooltipContent extends Component {
  constructor(...args) {
    super(...args);
    this.getHandleErrorFocus = error => () => {
      const {
        onErrorFocus
      } = this.props;
      onErrorFocus({
        error,
        step: getStepByError(error)
      });
    };
    this.renderError = (error, missingVariantCategoryLanguages, missingVariantSubcategoryLanguages) => {
      if (error === ErrorTypes.ARTICLE_LANGUAGE_NOT_SUPPORTED_BY_KNOWLEDGE_BASE) {
        return /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: `${I18N_PREFIX}.isInvalid`,
          options: {
            inputFieldName: /*#__PURE__*/_jsx(_Fragment, {
              children: /*#__PURE__*/_jsx(Link, {
                "data-test-id": `error-tooltip-${error}`,
                onClick: this.getHandleErrorFocus(error),
                color: 'fill-info-default',
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: `${I18N_PREFIX}.error.${error}`
                })
              })
            })
          }
        });
      }
      return /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: `${I18N_PREFIX}.isRequired`,
        options: {
          inputFieldName: /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(Link, {
              "data-test-id": `error-tooltip-${error}`,
              onClick: this.getHandleErrorFocus(error),
              color: 'fill-info-default',
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: `${I18N_PREFIX}.error.${error}`
              })
            }), missingVariantCategoryLanguages && error === 'variantCategoryTranslation' && /*#__PURE__*/_jsx(FormattedMessage, {
              message: `${I18N_PREFIX}.error.variantCategoryTranslationLanguages`,
              options: {
                languages: missingVariantCategoryLanguages.join(', ')
              }
            }), missingVariantSubcategoryLanguages && error === 'variantSubcategoryTranslation' && /*#__PURE__*/_jsx(FormattedMessage, {
              message: `${I18N_PREFIX}.error.variantSubcategoryTranslationLanguages`,
              options: {
                languages: missingVariantSubcategoryLanguages.join(', ')
              }
            })]
          })
        }
      });
    };
  }
  render() {
    const {
      errors,
      missingVariantCategoryLanguages,
      missingVariantSubcategoryLanguages
    } = this.props;
    if (errors.length === 0) {
      return null;
    }
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(ErrorsAndWarningsTooltipHeader, {
        iconColor: 'fill-accent-red-default',
        langKey: `${I18N_PREFIX}.header`
      }), /*#__PURE__*/_jsx(List, {
        ordered: true,
        styled: true,
        wrapChildren: true,
        children: errors.map(error => /*#__PURE__*/_jsx("span", {
          children: this.renderError(error, missingVariantCategoryLanguages, missingVariantSubcategoryLanguages)
        }, error))
      })]
    });
  }
}
ErrorsTooltipContent.propTypes = {
  errors: PropTypes.array.isRequired,
  onErrorFocus: PropTypes.func.isRequired,
  missingVariantCategoryLanguages: PropTypes.arrayOf(PropTypes.string),
  missingVariantSubcategoryLanguages: PropTypes.arrayOf(PropTypes.string)
};
export default ErrorsTooltipContent;